<template>
  <h1>Страница не существует</h1>
</template>

<script>
export default {
  name: "NotFound",
  methods: {},
}
</script>

<style scoped>

</style>
